<div class="group-name">
  <ng-content></ng-content>
</div>
